<script setup>
import { computed } from 'vue';
import { useMessageContext } from '../../provider.js';

import MessageFormatter from 'shared/helpers/MessageFormatter.js';
import { MESSAGE_VARIANTS } from '../../constants';

const props = defineProps({
  content: {
    type: String,
    required: true,
  },
});

const { variant } = useMessageContext();

const formattedContent = computed(() => {
  if (variant.value === MESSAGE_VARIANTS.ACTIVITY) {
    return props.content;
  }

  return new MessageFormatter(props.content).formattedMessage;
});

const proseClass = computed(() => {
  const baseClass =
    'prose prose-bubble max-w-none break-words text-current [&_a]:font-medium [&_a]:text-current [&_a]:underline [&_code]:text-current [&_em]:text-current [&_li]:text-current [&_ol]:text-current [&_p]:text-current [&_strong]:text-current [&_ul]:text-current';

  if (
    [
      MESSAGE_VARIANTS.AGENT,
      MESSAGE_VARIANTS.BOT,
      MESSAGE_VARIANTS.TEMPLATE,
      MESSAGE_VARIANTS.PRIVATE,
      MESSAGE_VARIANTS.ERROR,
    ].includes(variant.value)
  ) {
    return `${baseClass} [&_blockquote]:border-white/35 [&_blockquote]:text-current`;
  }

  return `${baseClass} [&_blockquote]:border-n-slate-5 [&_blockquote]:text-current`;
});
</script>

<template>
  <span v-dompurify-html="formattedContent" :class="proseClass" />
</template>
